jQuery(document).ready(function($){
	//if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well

	// var $L = 766,
	var $L = 1024,
			$menu_navigation = $('#mobile-nav'),
			$cart_trigger = $('#minicart, .add-to-cart, .quick-cart, #add-quickview'),
			$hamburger_icon = $('#cd-hamburger-menu'),
			$lateral_cart = $('#cd-cart'),
			$shadow_layer = $('#cd-shadow-layer, a.close, .close-cart'),
			$hamburger_menu = $("#mobile-hamburger");


// navcart hover
  $('.no-mobile .minicart_wrapper.items-in-cart').mouseenter(function() {
  //add the class of hover on mouse enter
    $(this).addClass('hover');
    
    $('.hover .minicart_info').velocity({height:"116px", opacity:1},{ visibility: "visible" }, {duration: 50,delay:50, easing:"easeOut"});
    
    //mouseleave
  }).mouseleave(function() {
    //stop any current animation

    $('.hover .minicart_info').velocity('reverse');
    
  
    
    $(this).removeClass('hover');
  });
 









	//open lateral menu on mobile
	$hamburger_icon.on('click', function(event){
		console.log('clicked');
		event.preventDefault();
		//close cart panel (if it's open)
		$lateral_cart.removeClass('speed-in');
		toggle_panel_visibility($menu_navigation, $shadow_layer, $('body'));
	});

	$('.pt_product_details #cd-hamburger-menu').click(function() {
		$('#mobile-nav').toggleClass('speed-in');
	});

	//open cart
	$cart_trigger.on('click', function(event){		

		setTimeout( function() {
			event.preventDefault();
			//close lateral menu (if it's open)
			$menu_navigation.removeClass('speed-in');
			toggle_panel_visibility($lateral_cart, $shadow_layer, $('body'));
		}, 200);
	});
 
	//close lateral cart or lateral menu
	$shadow_layer.on('click', function(){
		$shadow_layer.removeClass('is-visible');
		// firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
		if( $lateral_cart.hasClass('speed-in') ) {
			$lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
				$('body').removeClass('overflow-hidden');
			});
			$menu_navigation.removeClass('speed-in');
		} else {
			$menu_navigation.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
				$('body').removeClass('overflow-hidden');
			});
			$lateral_cart.removeClass('speed-in');
		}
	});

	//move #main-navigation inside header on laptop
	//insert #main-navigation after header on mobile
	move_navigation( $menu_navigation, $L);
	$(window).on('resize', function(){
		move_navigation( $menu_navigation, $L);
		
		if( $(window).width() >= $L && $menu_navigation.hasClass('speed-in')) {
			$menu_navigation.removeClass('speed-in');
			$shadow_layer.removeClass('is-visible');
			$('body').removeClass('overflow-hidden');
		}

	});

	// Mobile toggle menu
	$('#cd-hamburger-menu').click(function() {
		$hamburger_menu.toggleClass('open');
		$('header').toggleClass('is-active');
	});

	$('#minicart').click(function() {
		$hamburger_menu.removeClass('open');
		console.log('minicart clicked');
		setTimeout(function(){
			$('header').removeClass('is-active');
		}, 200);
	});

	$(".close-cart, #cd-shadow-layer").click(function() {
		$(".product-details-contents").removeClass('is-active');
		$("html, body").removeClass('overflow-hidden');
	});

	if ((typeof Shopify) === 'undefined') { Shopify = {}; }
	Shopify.getCart = Shopify.getCart || function(callback) {
	  jQuery.getJSON('/cart.js', function (cart, textStatus) {
	    if ((typeof callback) === 'function') {
	      callback(cart);
	    }
	    else {
	      Shopify.onCartUpdate(cart);
	    }
	  });
	};
	
	updateInlineCart = function() {      
	  var items = CartJS.cart.items;
	  var totalPrice = 0;
	  var inlineCartItems = '';
	  if (items.length > 0) {
	  	$('#minicart').addClass('has-items');
	  	$('.minicart_wrapper').addClass('items-in-cart');
        setTimeout(function(){
			$('#minicart .mini_cart_quantity').text(CartJS.cart.item_count);
		}, 200);
	  }
	  else {
	  	$('#minicart').removeClass('has-items');
	  	$('.minicart_wrapper').removeClass('items-in-cart');
	  }
	  if (items.length) { 
	    $('#cd-cart.no-items').removeClass('no-items');
	    for (var i = 0; i < items.length; i++) {
	      var item = items[i];
	      inlineCartItems +=
	        '<ul class="inline-cart-item">' +
	          '<li class="inline-cart-product-thumbnail">' +
	            '<a href="' + window.location.origin + item.url + '">' +
	              '<img src="' + item.image.replace(/(\.jpg|\.jpeg|\.png)/g, '_medium$1') + '" alt="" />' +
	            '</a>' +
	          '</li>' +
	          '<li class="inline-cart-product-details">' +
	            '<a href="' + window.location.origin + item.url + '">' +
	              '<div class="inline-cart-product-title">' + item.product_title + ' - ' + item.variant_options[0] + '</div>' +
	            '</a>' +
	            '<div class="inline-cart-product-price">$' + (item.price/100).toFixed(2) + '</div>' +
	            '<div class="input-holder">' +
	            	'<input class="inline-cart-product-quantity" min="1" data-variant-id="' + item.variant_id + '" data-price="'+ (item.price/100).toFixed(2) +'" min="0" pattern="\d*" type="number" value="' + item.quantity + '">' +
	            '</div>' +
		          '<div class="inline-cart-product-delete">' +
		            '<span class="remove-item" data-variant-id="' + item.variant_id + '">remove item</span>' +
		          '</div>' +
	          '</li>' +
	        '</ul>';
	      totalPrice = totalPrice + item.line_price;
	    }
	    $('.inline-cart-tophalf').html(inlineCartItems);
	  } else {  // carts empty bro, let's make sure customers know that
	    $('#cd-cart').addClass('no-items');  // add class to modal
	  }
	  $('.inline-cart-total-amount span:last-child').text('$' + (totalPrice/100).toFixed(2)); //and update the modal's total (try saying that 10 times fast)
	};

	updateInlineCart();  // IIFE breaking everything when it's called elsewhere(?) This is compromise

	// remove item from cart
	$('.inline-cart-tophalf').on('click', '.inline-cart-product-delete span', function() {
	  CartJS.updateItemById($(this).attr('data-variant-id'), 0);
	  $(document).on('cart.requestComplete', function(event, cart) {
		  Shopify.getCart (function (cart) {
			  CartJS.cart = cart;
		      updateInlineCart();
		  })
	  });
	});
	// direct checkout
	$('.inline-cart-checkout-button').click(function() {
	  window.location.href = window.location.origin + '/cart';
	});

	$( ".quick-cart, #add-quickview" ).click(function() {
	  CartJS.addItem($(this).attr('data-variant-id'));
	  $(document).on('cart.requestComplete', function(event, cart) {
		  Shopify.getCart (function (cart) {
			  CartJS.cart = cart;
		      updateInlineCart();
		  })
	  });
	});



// KR product page add to cart with qty add
	$( ".add-to-cart" ).click(function() {
		var addID = $(this).attr('data-variant-id'),
			  addQTY = $(this).attr('data-variant-qty');
	 	  CartJS.addItem(addID, addQTY);
		  $(document).on('cart.requestComplete', function(event, cart) {
			  Shopify.getCart (function (cart) {
				  CartJS.cart = cart;
			      updateInlineCart();
			  })
		  });
	});

//qty select box
//$( ".pg-product-details .input-number" ).change(function() {
//  var valQTY = $(this).val();
 // $('.add-to-cart').attr('data-variant-qty', valQTY);
//});
 

  $(document).on('change', '.inline-cart-product-quantity', function() {
    var total = 0;
    $('.inline-cart-product-quantity').each(function() {
    	total += $(this).val() * $(this).data('price');
    	console.log($(this).data('price'));
    });
    $(".cart-total").text("$"+total.toFixed(2));
        
  });

  $(document).on('blur', '.inline-cart-product-quantity', function() {
  	CartJS.updateItemById($(this).data('variant-id'), $(this).val(),{},{"success":function(){Shopify.getCart(function (cart) {CartJS.cart = cart;updateInlineCart();if(typeof SECOMAPP !=='undefined' && SECOMAPP.isCartPage ===true){SECOMAPP.fgcallback=null;}})}});
    
  });

  $(document).on('click', '.quick-cart', function() {
    CartJS.updateItemById($(this).data('variant-id'), $(this).val() + 1,{},{"success":function(){console.log('success');Shopify.getCart(function (cart) {CartJS.cart = cart;updateInlineCart();if(typeof SECOMAPP !=='undefined' && SECOMAPP.isCartPage ===true){SECOMAPP.fgcallback=null;}})}});
        
  });

});

function toggle_panel_visibility ($lateral_panel, $background_layer) {
	if( $lateral_panel.hasClass('speed-in') ) {
		// firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
		$lateral_panel.removeClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
			$("html, body").removeClass('overflow-hidden');
		});
		$background_layer.removeClass('is-visible');

	} else {
		$lateral_panel.addClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
			$("html, body").addClass('overflow-hidden');
		});
		$background_layer.addClass('is-visible');
	}
}

function move_navigation( $navigation, $MQ) {
	if ( $(window).width() >= $MQ ) {
		$navigation.detach();
		$navigation.appendTo('.header');
		$("#mobile-nav #main-nav").prependTo('nav');
	} else {
		$navigation.detach();
		$navigation.insertAfter('.header');
		$("nav #main-nav").prependTo('#mobile-nav');
	}
}